// Compiled at 2026-09-18T12:45:23.821Z
// Auto-generated by Lowgile
import { unwrapReadonly, assignCommonProperties, coerceDataType, createReadonlyProxy } from "@lg/shared/for-apps";
import * as Ramda from "ramda";
import * as $Modules from "../../Module/$modules.js";
import { Orders, Orders as This, System, Common } from "../../Module/$modules.js";
import type { HasId, IdType, Class, DeepReadonly, NominalType } from "@lg/shared";
import { Sys, ExecutionService } from "@lg/ng-shared";
import type { OnAfterCodeLoad } from "@lg/shared";
import { BoInfoSymbol, HasChangedInternallySymbol } from "@lg/shared/for-apps";
// Auto-generated by Lowgile
import { jsonClass, jsonProperty } from "@sumbricht/json-class-serializer";
import { proxySignal, ProxySignal, signal, computed, Signal } from "../../signals.js";
import { HasSignalProperties } from "@lg/shared/for-apps";
import { immerable } from "immer";
import { DataLoader } from "@lg/shared/for-apps";
import { Subject } from "rxjs";
import { z } from "zod";
import { AppContext } from "@lg/ng-shared";
import { ChangeDetectorRef } from "@angular/core";

const θdataLoader =
    new DataLoader(() => VendorOfferStatus.loadInternal(), entryList => {
        VendorOfferStatus.θentryList.set(entryList)
        VendorOfferStatus.θonEntryListUpdated()
    }, { doCache: true, expireAfterMs: 0 })
    ;

// Auto-generated by Lowgile
export class VendorOfferStatus {
    readonly [BoInfoSymbol] = Object.freeze({
        boType: "StaticEntity" as const,
        editablePropertyNames: ["id"] as const,
        computedPropertyNames: ["label"] as const,
        allPropertyNames: ["id", "label"] as const,
        propertyNamesOfInterest: [] as const,
    });
    readonly [HasSignalProperties] = true;
    readonly [HasChangedInternallySymbol] = new Subject<void>();
    readonly θid: ProxySignal<VendorOfferStatus.Id | null>;
    static readonly Id = String;
    static ids: VendorOfferStatus.Id[] = [] as any;
    static idsAndDisplayValues: Record<VendorOfferStatus.Id, string> = {} as any;
    static θentryList = signal<VendorOfferStatus.Entry[] | undefined>(this.θgetStaticEntryList());
    static θentryMap = computed(() => {
        const objEntries = this.θentryList()?.map(e => [e.id, e]) ?? []
        return Object.freeze(Object.fromEntries(objEntries))
    });
    static θchoicesCache = new Map<string, Sys.Types.Choice[]>();
    static θfilteredCache = new Map<string, Signal<VendorOfferStatus.Entry[]>>();
    readonly θhasOthers = false;
    static readonly $displayProperty = 'label';
    [immerable] = true;
    readonly θlabel = computed(() => {
        const id = this.θid()
        return id !== null ? VendorOfferStatus.getEntryMap()[id]?.label : undefined
    });
    readonly $isOther = false;

    static get [BoInfoSymbol]() {
        return VendorOfferStatus[BoInfoSymbol]
    }

    get __type(): 'Orders.VendorOfferStatus' {
        return 'Orders.VendorOfferStatus'
    }

    set __type(_) {
    }

    static get __type(): 'Orders.VendorOfferStatus' {
        return 'Orders.VendorOfferStatus'
    }

    static set __type(_) {
    }

    @jsonProperty()
    get id(): VendorOfferStatus.Id | null {
        return this.θid()
    }

    set id(id: VendorOfferStatus.Id | VendorOfferStatus | null) {
        if (id !== null && typeof id == 'object') { id = id.id }

        if (id != null && !VendorOfferStatus.getEntry(id as VendorOfferStatus.Id)) throw new Error('Invalid id for type Orders.VendorOfferStatus: ' + id)
        this.θid.set(id as VendorOfferStatus.Id | null)
        this[HasChangedInternallySymbol].next()
    }

    get __boType(): 'StaticEntity' {
        return 'StaticEntity'
    }

    static get __boType(): 'StaticEntity' {
        return 'StaticEntity'
    }

    get ids(): VendorOfferStatus.Id[] {
        return VendorOfferStatus.ids
    }

    get idsAndDisplayValues(): Record<VendorOfferStatus.Id, string> {
        return VendorOfferStatus.idsAndDisplayValues
    }

    get $displayValue(): string {
        return this.$isOther ? (this as any).$other : String((this as any)[VendorOfferStatus.$displayProperty])
    }

    get label() {
        return this.θlabel()
    }

    get isNotRequested() {
        return this.id == 'notRequested'
    }

    static get NotRequested() {
        return new this('notRequested')
    }

    get isPendingReply() {
        return this.id == 'pendingReply'
    }

    static get PendingReply() {
        return new this('pendingReply')
    }

    get isReceived() {
        return this.id == 'received'
    }

    static get Received() {
        return new this('received')
    }

    get isError() {
        return this.id == 'error'
    }

    static get Error() {
        return new this('error')
    }

    get isNotReceivedInTime() {
        return this.id == 'notReceivedInTime'
    }

    static get NotReceivedInTime() {
        return new this('notReceivedInTime')
    }

    constructor(idOrObject: VendorOfferStatus.Id | VendorOfferStatus | null = null) {
        const { id } = this.θtoIdAndOther(idOrObject)
        this.θid = proxySignal(id)

    }

    getEntryList(filters?: { entryProperty: string, values: any[] }[]): VendorOfferStatus.Entry[] {
        return This.VendorOfferStatus.getEntryList(filters)
    }

    static getEntryList(filters?: { entryProperty: string, values: any[] }[]): VendorOfferStatus.Entry[] {
        if (filters) {
            const key = JSON.stringify(filters)
            let filteredList = this.θfilteredCache.get(key)
            if (!filteredList) {
                filteredList = computed(() => this.θentryList()?.filter(entry => filters.every(filter => filter.values.includes(entry[filter.entryProperty]))) ?? [])
                this.θfilteredCache.set(key, filteredList)
            }

            return filteredList()
        }

        return this.θentryList()
    }

    static getEntryMap() {
        return this.θentryMap()
    }

    static getEntry(id: VendorOfferStatus.Id) {
        const entryMap = this.getEntryMap()
        return entryMap[id]
    }

    static getChoices(labelColumn: keyof VendorOfferStatus.Entry = '$displayValue'): Sys.Types.Choice[] {
        if (labelColumn == "$displayValue") labelColumn = VendorOfferStatus.$displayProperty
        let options = this.θchoicesCache.get(labelColumn)
        if (!options) {
            const entryList = this.getEntryList() ?? []
            options = entryList.map(entry => ({ id: entry.id, label: String(entry[labelColumn]), $isOther: false }))
            this.θchoicesCache.set(labelColumn, options)
        }

        return options
    }

    static async load(forceReload = false) {
        if (forceReload) {
            this.θentryList.set(await θdataLoader.forceReloadAndGetData())
        } else {
            this.θentryList.set(await θdataLoader.waitAndGetValidData())
        }

        this.θonEntryListUpdated()
        return this.θentryList()
    }

    static async loadInternal(): Promise<VendorOfferStatus.Entry[]> {
        const dynamicEntryList = []
        this.θchoicesCache.clear()
        return createReadonlyProxy(true, [...this.θgetStaticEntryList(), ...dynamicEntryList])
    }

    toJSON() {
        return this.id
    }

    $clone() {
        return new VendorOfferStatus(this.id)
    }

    $equals(other: any) {
        if (this.id !== other?.id) return false

        return true
    }

    θtoPlainObject() {
        return this.id
    }

    θtoIdAndOther(idOrObject: VendorOfferStatus.Id | VendorOfferStatus | null) {
        if (idOrObject && typeof idOrObject == 'object') {
            return { id: idOrObject.id }

        } else {
            return { id: idOrObject as VendorOfferStatus.Id | null, otherValue: '' }

        }
    }

    θupdate(idOrObject: VendorOfferStatus.Id | VendorOfferStatus) {
        const { id } = this.θtoIdAndOther(idOrObject)
        this.θid.set(id)

    }

    static θonEntryListUpdated() {
        this.ids = this.getEntryList().map(e => e.id)
        this.idsAndDisplayValues = Object.fromEntries(this.getEntryList().map(e => [e.id, e.$displayValue] as const)) as Record<VendorOfferStatus.Id, string>
        AppContext.resolve(ChangeDetectorRef).detectChanges()
    }

    static async θafterCodeLoad() {
        return this.load().catch(err => {
            console.log('Could not load entries of StaticEntity Orders.VendorOfferStatus yet:', err.message)
            //throw err
        })
    }

    setNotRequested() {
        this.id = 'notRequested'

    }

    setPendingReply() {
        this.id = 'pendingReply'

    }

    setReceived() {
        this.id = 'received'

    }

    setError() {
        this.id = 'error'

    }

    setNotReceivedInTime() {
        this.id = 'notReceivedInTime'

    }

    static θgetStaticEntryList() {
        return Object.freeze([
            Object.freeze({ id: "notRequested", label: "Not requested" }),
            Object.freeze({ id: "pendingReply", label: "Pending reply" }),
            Object.freeze({ id: "received", label: "Received" }),
            Object.freeze({ id: "error", label: "Error" }),
            Object.freeze({ id: "notReceivedInTime", label: "Not received in time" })
        ] as VendorOfferStatus.Entry[]) as VendorOfferStatus.Entry[]
    }
}
jsonClass('Orders.VendorOfferStatus')(VendorOfferStatus)

export const VendorOfferStatusθId = String;

export type VendorOfferStatusθId = string;

export namespace VendorOfferStatus {
    export type Id = 'notRequested' | 'pendingReply' | 'received' | 'error' | 'notReceivedInTime'

    export interface Entry {
        id: VendorOfferStatus.Id;
        label: string;
        $displayValue?: string;
    }
}
Sys.Language.languageChanged$.subscribe(() => VendorOfferStatus.load(true))
